export const FETCH_USER_DATA_REQUEST    =   'FETCH_USER_DATA_REQUEST '
export const FETCH_USER_DATA_FAILURE   =   'FETCH_USER_DATA_FAILURE '
export const FETCH_USER_DATA_SUCCESS    =   'FETCH_USER_DATA_SUCCESS '
